import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { Subscription } from 'rxjs';
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: 'app-stock-break',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDateRangeInput,
    ReactiveFormsModule,
    FilterComponent,
    MatMenuModule,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './stock-break.component.html',
  styleUrl: './stock-break.component.scss'
})
export class StockBreakComponent implements OnDestroy{
  displayedColumns: string[] = [
    "routeCode",
    "userCode",
    "executionDate",
    "itemCode",
    "executionHour",
    "customerPending",
    "customerAverage",
    "predictNeed",
    "existenceItem",
    "price",
    "predictSale",
    "lostSale",
    "unstockedHour",
    "difference",
    "lostSaleUm",
    "totalLostSale"
  ];

  dataSource = new MatTableDataSource<any[]>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex = 1
  sortActive = null
  sortDirection = 'asc'

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  //BUSCADOR
  searchSubscription: Subscription;

  constructor(
    private readonly searchService: SearchService,
  ) { }

  onFilter(){
    this.onHandleSearch();
    this.filter = {
      dateini: new Date(),
      dateend: new Date(),
    };

  }

  onClearFilter(){
    this.onFilter()
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getListReport()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.applyFilter(term)
      });
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getListReport()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getListReport()
  }

  getListReport(){
  }

  findAllWithCount(): void {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    const adjustedStart = new Date(this.filter.dateini);
    adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

    const adjustedEnd = new Date(this.filter.dateend);
    adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

    let date = {
      start: adjustedStart.toISOString(), // Convertir a UTC
      end: adjustedEnd.toISOString(), // Convertir a UTC
    };
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}